'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitSearch = exports.getCategoryWithGreatestResults = exports.getUpcomingAuctions = exports.getSelectedCategory = exports.getSelectedOrigin = exports.getSelectedStyle = exports.getSelectedMaterials = exports.getSelectedCreator = exports.isArchivedSearchFromLocation = exports.searchQueryFromParams = exports.getRawFacetsFromStateOrParams = exports.translateSortForOlderUrls = exports.concatenatePath = exports.findCategoryContainingSomeCategoryId = exports.isArchivedSearch = exports.isArchivedSearchByParams = exports.getSearchFacets = exports.getIsLoading = exports.getSort = exports.getSearchPageSize = exports.getSearchPage = exports.getSearchTotalItems = exports.getSearchFailed = exports.getSearchSubmitted = exports.getSearchedItems = exports.getSearchResults = exports.getSearchedParameters = exports.DEFAULT_SORT_ORDER = exports.DEFAULT_ARCHIVE_STATUSES = exports.DEFAULT_LIVE_STATUSES = exports.LOAD_SEARCH_RESULTS_SUCCESS = exports.LOAD_SEARCH_RESULTS_REQUEST = exports.LOAD_SEARCH_RESULTS_FAIL = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _user = require('./user');

var _searchParams = require('../../utils/searchParams');

var _searchFacets = require('../modules/searchFacets');

var _landingPage = require('../modules/landingPage');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _facetTypes = require('../../utils/search/facetTypes');

var _facetTypes2 = _interopRequireDefault(_facetTypes);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _config = require('../modules/config');

var _cardData = require('../modules/cardData');

var _pagination = require('../modules/pagination');

var _urls = require('../../utils/urls');

var _paramTypes = require('../../utils/search/paramTypes');

var _paramTypes2 = _interopRequireDefault(_paramTypes);

var _reject = require('lodash/reject');

var _reject2 = _interopRequireDefault(_reject);

var _some = require('lodash/some');

var _some2 = _interopRequireDefault(_some);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SEARCH_RESULTS_FAIL = exports.LOAD_SEARCH_RESULTS_FAIL = 'la/domain/searchResults/LOAD_FAIL';
var LOAD_SEARCH_RESULTS_REQUEST = exports.LOAD_SEARCH_RESULTS_REQUEST = 'la/domain/searchResults/LOAD_REQUEST';
var LOAD_SEARCH_RESULTS_SUCCESS = exports.LOAD_SEARCH_RESULTS_SUCCESS = 'la/domain/searchResults/LOAD_SUCCESS';

var MAX_VIEW_COUNT_FOR_SEARCH = 120;
var UNSUPPORT_SEARCH_VIEW_COUNT = 'all';
var DEFAULT_LIVE_STATUSES = exports.DEFAULT_LIVE_STATUSES = ['upcoming', 'live', 'online'];
var DEFAULT_ARCHIVE_STATUSES = exports.DEFAULT_ARCHIVE_STATUSES = ['sold', 'passed', 'done'];
var DEFAULT_SORT_ORDER = exports.DEFAULT_SORT_ORDER = '-relevance';

/* reducer */
var DEFAULT_STATE = {
    error: false,
    facets: [],
    isLoading: true,
    itemIDs: [],
    searchQuery: {
        options: {},
        page: 1
    },
    sort: [],
    submitted: false,
    success: false,
    totalFound: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_SEARCH_RESULTS_REQUEST:
        case _landingPage.LOAD_CATEGORY_RESULTS_REQUEST:
            return (0, _extends4.default)({}, state, {
                error: false,
                searchQuery: action.payload,
                submitted: true,
                success: false
            });
        case LOAD_SEARCH_RESULTS_SUCCESS:
        case _landingPage.LOAD_CATEGORY_RESULTS_SUCCESS:
            return (0, _extends4.default)({}, state, {
                facets: action.payload.facets,
                isLoading: false,
                itemIDs: action.payload.itemIDs,
                sort: action.payload.sort.filter(function (sortOption) {
                    return sortOption !== 'publishDate';
                }),
                submitted: false,
                success: true,
                totalFound: action.payload.totalFound
            });
        case LOAD_SEARCH_RESULTS_FAIL:
        case _landingPage.LOAD_CATEGORY_RESULTS_FAIL:
            return (0, _extends4.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var searchSelector = function searchSelector(state) {
    return state.ui.search;
};

var getSearchedParameters = exports.getSearchedParameters = function getSearchedParameters(state) {
    return state.ui.search.searchQuery;
};

var getSearchResults = exports.getSearchResults = function getSearchResults(state) {
    return state.ui.search.itemIDs || [];
};

var getSearchedItems = exports.getSearchedItems = function getSearchedItems(state) {
    var itemIDs = getSearchResults(state);
    return (0, _cardData.getItemCardDatas)(state, itemIDs);
};

var getSearchSubmitted = exports.getSearchSubmitted = function getSearchSubmitted(state) {
    return state.ui.search.submitted;
};

var getSearchFailed = exports.getSearchFailed = function getSearchFailed(state) {
    return state.ui.search.error;
};

var getSearchTotalItems = exports.getSearchTotalItems = function getSearchTotalItems(state) {
    return state.ui.search.totalFound;
};

var getSearchPage = exports.getSearchPage = function getSearchPage(state) {
    return state.ui.search.searchQuery.page;
};

var getSearchPageSize = exports.getSearchPageSize = function getSearchPageSize(state) {
    var pageSize = (0, _pagination.getPaginationPageSize)(state);
    return pageSize === UNSUPPORT_SEARCH_VIEW_COUNT ? Number(MAX_VIEW_COUNT_FOR_SEARCH) : Number(pageSize);
};

var getSort = exports.getSort = function getSort(state) {
    return state.ui.search.sort;
};

var getIsLoading = exports.getIsLoading = function getIsLoading(state) {
    return state.ui.search.isLoading;
};

// For each key in the exclusions object, find the raw facet with that key, and add
// it to the search facets array
var getSearchFacets = exports.getSearchFacets = (0, _reselect.createSelector)(searchSelector, _user.getUserExcludedFacets, _searchFacets.getRawSearchFacets, function (search, facetExclusions) {
    var rawFacets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var facets = (0, _cloneDeep2.default)(search.facets) || [];

    // for each exclusion, find the corresponding raw facet option, and add it
    (0, _keys2.default)(facetExclusions).forEach(function (complexFacetId) {
        var index = facets.findIndex(function (f) {
            return f.id === complexFacetId;
        });
        var complexFacet = rawFacets.find(function (f) {
            return f.id === complexFacetId;
        });
        if (index === -1 || !complexFacet || !complexFacet.options) return;

        // add excluded options to the options present in the search results
        facets[index].options = facetExclusions[complexFacetId].reduce(function (options, exclusion) {
            var includedOptionsIndex = options.findIndex(function (o) {
                return o.id === exclusion;
            });
            var rawFacetOption = complexFacet.options.find(function (o) {
                return o.id === exclusion;
            });
            if (!rawFacetOption) return options;
            if (includedOptionsIndex === -1) return [rawFacetOption].concat((0, _toConsumableArray3.default)(options));
            options.splice(includedOptionsIndex, 1, rawFacetOption);
            return options;
        }, facets[index].options || []);
    });

    return (0, _user.annotateFacetExclusions)(facets, facetExclusions);
});

var isArchivedSearchByParams = exports.isArchivedSearchByParams = function isArchivedSearchByParams(searchQuery) {
    var archiveSearch = true;

    DEFAULT_ARCHIVE_STATUSES.forEach(function (status) {
        archiveSearch = archiveSearch && searchQuery.options && searchQuery.options.status && searchQuery.options.status.some(function (optionStatus) {
            return optionStatus === status;
        });
    });

    return archiveSearch;
};

var isArchivedSearch = exports.isArchivedSearch = function isArchivedSearch(state) {
    var searchQuery = getSearchedParameters(state);
    return isArchivedSearchByParams(searchQuery);
};

var findCategoryContainingSomeCategoryId = exports.findCategoryContainingSomeCategoryId = function findCategoryContainingSomeCategoryId(categoryId, categories) {
    if (!categories) return false;
    var trees = categories;
    if ((0, _some2.default)(trees, function (c) {
        return c.id === categoryId;
    })) {
        return (0, _find2.default)(trees, function (c) {
            return c.id === categoryId;
        });
    }
    return (0, _find2.default)(trees, function (c) {
        return findCategoryContainingSomeCategoryId(categoryId, c.categories);
    });
};

var getParentPathForQuery = function getParentPathForQuery(category) {
    var categoryToQuery = '';
    if (category.selected && category.parents && category.parents.length > 0) {
        var parentsToQuery = '';
        category.parents.forEach(function (parent) {
            parentsToQuery += parent.id + '/';
        });
        categoryToQuery = '' + parentsToQuery + categoryToQuery;
    }
    return categoryToQuery;
};

var concatenatePath = exports.concatenatePath = function concatenatePath(category, catId) {
    if (!category) return catId;
    if (category.id === catId) {
        var categoryToQuery = category.id;
        categoryToQuery = '' + getParentPathForQuery(category) + categoryToQuery;

        return categoryToQuery;
    }
    var nextCategory = findCategoryContainingSomeCategoryId(catId, category.categories);

    return category.id + '/' + concatenatePath(nextCategory, catId);
};

var translateSortForOlderUrls = exports.translateSortForOlderUrls = function translateSortForOlderUrls(sortOption, defaultSortOrder) {
    var translatedSort = sortOption || defaultSortOrder;

    if (translatedSort.indexOf('_') > 0) {
        var oldUrl = sortOption.split('_');
        var newOption = oldUrl[0] + oldUrl[1].charAt(0).toUpperCase() + oldUrl[1].slice(1);
        translatedSort = newOption;
    }

    return translatedSort;
};

var translateStatus = function translateStatus(searchParams, location) {
    var status = DEFAULT_LIVE_STATUSES;

    if (searchParams.status === 'archive' || location.pathname && location.pathname.includes((0, _urls.getPriceGuideBaseUrl)())) {
        status = DEFAULT_ARCHIVE_STATUSES;
    }

    return status;
};

var getRawFacetsFromStateOrParams = exports.getRawFacetsFromStateOrParams = function getRawFacetsFromStateOrParams(state, searchQuery) {
    var facets = (0, _searchFacets.getRawSearchFacets)(state);

    if (!!facets) {
        facets = (0, _searchFacets.getRawSearchFacetsByParams)(state, searchQuery);
    }

    return facets;
};

/* this should only be called server side */
var searchQueryFromParams = exports.searchQueryFromParams = function searchQueryFromParams(state, location) {
    var defaultSortOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_SORT_ORDER;

    var searchParams = (0, _searchParams.getSearchParams)(location);
    var searchPageSize = getSearchPageSize(state);
    var translateSort = translateSortForOlderUrls(searchParams.sort, defaultSortOrder);
    var status = translateStatus(searchParams, location);
    var searchQuery = {
        campaignId: searchParams.campaignId,
        categories: [],
        distance: {},
        options: {
            status: status
        },
        page: searchParams.page || 1,
        pageSize: searchPageSize,
        ranges: {},
        searchTerm: searchParams.keyword ? searchParams.keyword : '',
        sort: translateSort
    };

    var categoryIds = searchParams.category_id;

    var facets = getRawFacetsFromStateOrParams(state, searchQuery);
    if (categoryIds) {
        var treeFacets = facets.filter(function (f) {
            return f.id === _facetTypes2.default.CATEGORY_ID || f.id === _facetTypes2.default.ORIGIN_ID;
        });
        var flatCategoryFacets = (0, _reject2.default)(facets, function (f) {
            return f.id === _facetTypes2.default.CATEGORY_ID || f.id === _facetTypes2.default.ORIGIN_ID || !f.options || f.id === _facetTypes2.default.AUCTION_HOUSE_ID;
        });

        categoryIds.split(',').forEach(function (categoryId) {
            var facetOption = (0, _find2.default)(flatCategoryFacets, function (f) {
                return (0, _some2.default)(f.options, function (o) {
                    return o.id === categoryId;
                });
            });
            if (facetOption) {
                if (!searchQuery.options[facetOption.id]) {
                    searchQuery.options[facetOption.id] = [];
                }
                searchQuery.options[facetOption.id].push(categoryId);
            } else {
                var rootCategory = findCategoryContainingSomeCategoryId(categoryId, treeFacets);
                searchQuery.categories.push(concatenatePath(rootCategory, categoryId));
            }
        });
    }

    (0, _keys2.default)(searchParams).forEach(function (key) {
        if (key === _paramTypes2.default.PAGE || key === _paramTypes2.default.PAGE_SIZE_LEGACY_SUPPORT || key === _paramTypes2.default.PAGE_SIZE || key === _paramTypes2.default.CATEGORY_ID || key === _paramTypes2.default.KEYWORD || key === _paramTypes2.default.SORT || key === _paramTypes2.default.STATUS || key === _paramTypes2.default.CAMPAIGN_ID) return;

        var convertedKey = (0, _searchParams.getFacetFromSearchQueryParameter)(key);
        var isRangeFacet = convertedKey === _facetTypes2.default.ESTIMATED_PRICE_ID || convertedKey === _facetTypes2.default.CURRENT_BID_ID || convertedKey === _facetTypes2.default.HAMMER_PRICE_ID;
        var isDistanceFacet = convertedKey === _facetTypes2.default.DISTANCE_ID;
        if (isRangeFacet) {
            var minMaxMatches = searchParams[key].match(/-?\d+/g);
            if (!searchQuery.ranges[convertedKey]) {
                searchQuery.ranges[convertedKey] = {};
            }
            var minValue = Number(minMaxMatches[0]);
            var maxValue = Number(minMaxMatches[1]);
            searchQuery.ranges[convertedKey].min = minValue === -1 ? null : minValue;
            searchQuery.ranges[convertedKey].max = maxValue === -1 ? null : maxValue;
        } else if (isDistanceFacet) {
            var distanceOptions = searchParams[key].split(':');
            searchQuery.distance.country = distanceOptions[0];
            searchQuery.distance.zipCode = distanceOptions[1];
            searchQuery.distance.space = Number(distanceOptions[2]);
            searchQuery.distance.measurement = distanceOptions[3];
        } else {
            var arrayParams = searchParams[key].split(',');
            searchQuery.options[convertedKey] = arrayParams;
        }
    });

    return searchQuery;
};

var isArchivedSearchFromLocation = exports.isArchivedSearchFromLocation = function isArchivedSearchFromLocation(state, location) {
    var currentSearchParams = searchQueryFromParams(state, location);
    return isArchivedSearchByParams(currentSearchParams) || location.pathname.includes((0, _urls.getPriceGuideBaseUrl)());
};

var getSelectedOptionFacetValues = function getSelectedOptionFacetValues(state, facetId) {
    var facets = getSearchFacets(state);
    var facetValues = facets.find(function (f) {
        return f.id === facetId;
    });
    var selectedFacetsValues = facetValues && facetValues.options ? facetValues.options.find(function (f) {
        return f.selected;
    }) : {};
    return selectedFacetsValues || {};
};

var getSelectedTreeFacetValues = function getSelectedTreeFacetValues(state, facetId) {
    var facets = getSearchFacets(state);
    var categoryFacets = facets.find(function (f) {
        return f.id === facetId;
    });
    var category = categoryFacets && categoryFacets.categories.facets.length > 0 ? categoryFacets.categories.facets.find(function (f) {
        return f.selected;
    }) : {};
    return category || {};
};

var getSelectedCreator = exports.getSelectedCreator = function getSelectedCreator(state) {
    return getSelectedOptionFacetValues(state, _facetTypes2.default.CREATOR_ID);
};

var getSelectedMaterials = exports.getSelectedMaterials = function getSelectedMaterials(state) {
    return getSelectedOptionFacetValues(state, _facetTypes2.default.MATERIALS_AND_TECHNIQUES_ID);
};

var getSelectedStyle = exports.getSelectedStyle = function getSelectedStyle(state) {
    return getSelectedOptionFacetValues(state, _facetTypes2.default.STYLE_PERIOD_ID);
};

var getSelectedOrigin = exports.getSelectedOrigin = function getSelectedOrigin(state) {
    return getSelectedTreeFacetValues(state, _facetTypes2.default.ORIGIN_ID);
};

var getSelectedCategory = exports.getSelectedCategory = function getSelectedCategory(state) {
    return getSelectedTreeFacetValues(state, _facetTypes2.default.CATEGORY_ID);
};

var getUpcomingAuctions = exports.getUpcomingAuctions = function getUpcomingAuctions(state) {
    var facets = getSearchFacets(state);
    var facetValues = facets.find(function (f) {
        return f.id === _facetTypes2.default.AUCTION_HOUSE_ID;
    });
    return facetValues ? facetValues.options.length : 0;
};

var getCategoryWithGreatestResults = exports.getCategoryWithGreatestResults = function getCategoryWithGreatestResults(state) {
    var facets = getSearchFacets(state);
    var categoryFacets = facets.find(function (f) {
        return f.id === _facetTypes2.default.CATEGORY_ID;
    });
    var category = categoryFacets && categoryFacets.categories && categoryFacets.categories.facets.length > 0 ? categoryFacets.categories.facets[0] : {};
    return category;
};

/* ACTION CREATORS */
var searchResultsFail = function searchResultsFail(searchQuery, error) {
    return {
        error: true,
        meta: { searchQuery: searchQuery },
        payload: error,
        type: LOAD_SEARCH_RESULTS_FAIL
    };
};

var searchResultsRequest = function searchResultsRequest(searchQuery) {
    return {
        payload: searchQuery,
        type: LOAD_SEARCH_RESULTS_REQUEST
    };
};

var searchResultsSuccess = function searchResultsSuccess(results) {
    return {
        payload: results,
        type: LOAD_SEARCH_RESULTS_SUCCESS
    };
};

var submitSearch = exports.submitSearch = function submitSearch(searchQuery) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(searchResultsRequest(searchQuery));

        // Annotate facets which have user-defined search exclusions
        var searchExclusions = (0, _user.getUserExcludedFacets)(state);
        var augmentedOptions = !searchExclusions ? searchQuery.options : (0, _keys2.default)(searchExclusions).reduce(function (options, facetWithExclusions) {
            return (0, _extends4.default)({}, options, (0, _defineProperty3.default)({}, facetWithExclusions, [{
                exclude: searchExclusions[facetWithExclusions] || [],
                include: searchQuery.options[facetWithExclusions] || []
            }]));
        }, (0, _extends4.default)({}, searchQuery.options));
        var augmentedSearchQuery = (0, _extends4.default)({}, searchQuery, {
            options: augmentedOptions
        });

        return _api.Search.fetchSearchResults({ deployment: deployment, searchQuery: augmentedSearchQuery }).then(function (results) {
            if (results.errorMessage) {
                dispatch(searchResultsFail(searchQuery, results));
            } else {
                dispatch(searchResultsSuccess(results));
            }
        }).catch(function (error) {
            dispatch(searchResultsFail(searchQuery, error));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/search.js
// module id = 9ad9
// module chunks = 57